/* tslint:disable */

declare var Object: any;
export interface VoiceServiceInterface {
  "id"?: number;
}

export class VoiceService implements VoiceServiceInterface {
  "id": number;
  constructor(data?: VoiceServiceInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `VoiceService`.
   */
  public static getModelName() {
    return "VoiceService";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of VoiceService for dynamic purposes.
  **/
  public static factory(data: VoiceServiceInterface): VoiceService{
    return new VoiceService(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'VoiceService',
      plural: 'VoiceServices',
      path: 'VoiceServices',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}
